module.exports = __webpack_public_path__ + "static/img/085_TO8_1738.ef99cf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/085_TO8_1738.jpg
// module id = DJVW
// module chunks = 0